import React from 'react'
import { useSelector } from 'react-redux'
import TileLayer from '../Layers/TileLayer'
import cartoDB from '../Source/cartoDB'
import cartoDBPositron from '../Source/cartoDBPositron'

import osm from '../Source/osm'
import ESRIWorldImagery from '../Source/ESRIWorldImagery'
import ESRILightGray from '../Source/ESRILightGrayCanvas'
import ESRIDarkGray from '../Source/ESRIDarkGrayCanvas'

const BaseMap = ({ isVisibly, children }) => {
  if (isVisibly) {
    return children
  }
  return null
}

export default function BaseMaps() {
  const baseMap = useSelector((state) => state.mapStates.baseMap)

  return (
    <>
      {/* <BaseMap isVisibly={baseMap === 'cartoDark'}> */}
      {/*   <TileLayer source={cartoDB()} zIndex={1}></TileLayer> */}
      {/* </BaseMap> */}
      <BaseMap isVisibly={baseMap === 'osm'}>
        <TileLayer source={osm()} zIndex={1}></TileLayer>
      </BaseMap>
      <BaseMap isVisibly={baseMap === 'Esri_WorldImagery'}>
        <TileLayer source={ESRIWorldImagery()} zIndex={1}></TileLayer>
      </BaseMap>
      {/* <BaseMap isVisibly={baseMap === 'cartoPositron'}> */}
      {/*   <TileLayer source={cartoDBPositron()} zIndex={1}></TileLayer> */}
      {/* </BaseMap> */}
      <BaseMap isVisibly={baseMap === 'Esri_LightGray'}>
        <TileLayer source={ESRILightGray()} zIndex={1}></TileLayer>
      </BaseMap>
      <BaseMap isVisibly={baseMap === 'Esri_DarkGray'}>
        <TileLayer source={ESRIDarkGray()} zIndex={1}></TileLayer>
      </BaseMap>
    </>
  )
}
